/* VELTRA promo runtime — 2026-10-22
   1) 促销条 / PDP 提示到 2026-11-05 23:59 (CET) 自动下线
   2) 公告条里那条促销文案同一天自动隐藏，回落到原来的免运费文案
   3) PDP 价格下方注入一行「20% off applied at checkout」 */
(function () {
  var ENDS = new Date('2026-11-05T23:59:59+01:00');
  var ENDS_LABEL = '5 Nov';
  var live = Date.now() < ENDS.getTime();

  function hidePromoAnnouncement() {
    var nodes = document.querySelectorAll('[data-testid*="announcement"], .announcement, .announcement-bar__text, .announcements__item, li');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.textContent) continue;
      if (el.textContent.indexOf('20% OFF THE FIRST DROP') === -1) continue;
      var host = el.closest('[data-testid*="announcement"], .announcement, .announcements__item') || el;
      if (host.parentElement) host.parentElement.style.display = 'none';
      else host.style.display = 'none';
    }
  }

  function daysLeft() {
    return Math.max(1, Math.ceil((ENDS.getTime() - Date.now()) / 86400000));
  }

  function stampDays() {
    var em = document.querySelector('.vpr-num em');
    if (em) em.textContent = daysLeft() + ' days left · ' + ENDS_LABEL;
  }

  function injectPdpLine() {
    if (!/\/products\//.test(location.pathname)) return;
    var old = document.querySelector('.veltra-promo-pdp');
    if (old) old.parentElement.removeChild(old);

    // 只在主商品信息区里的价格下方插，跳过底部的 sticky add-to-cart 条
    var scope =
      document.querySelector('.product-info, .product__info, .product-information, [data-testid="product-info"]') ||
      document.querySelector('main') ||
      document;
    var prices = document.querySelectorAll('.price, .product-price, [data-testid="product-price"]');
    var target = null;
    for (var i = 0; i < prices.length; i++) {
      var el = prices[i];
      if (el.closest('.sticky-add-to-cart')) continue;      // 底部的吸底条跳过
      var r = el.getBoundingClientRect();
      if (!r.width || r.y > 700) continue;                  // 只认首屏可见的主价格
      target = el;
      break;
    }
    if (!target) return;
    var host = target.parentElement && target.parentElement.parentElement ? target.parentElement : target;
    var p = document.createElement('p');
    p.className = 'veltra-promo-pdp';
    p.textContent = '20% off applied at checkout · ends ' + ENDS_LABEL;
    host.insertAdjacentElement('afterend', p);
  }

  function run() {
    if (!live) {
      var bar = document.querySelector('.vpr');
      if (bar) bar.style.display = 'none';
      hidePromoAnnouncement();
      return;
    }
    stampDays();
    injectPdpLine();
    setTimeout(injectPdpLine, 1200);
    setTimeout(stampDays, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
